import { createContext } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { RegulationContract } from '@raas/shared/src/features/regulation/contracts/regulation.type';
import type { IDocumentElementDetails } from '@raas/shared/src/types/document-element';

export interface RegulationDataContextContract {
  currentRegulation: RegulationContract | null;
  isLoading: boolean;
  setCurrentRegulation: Dispatch<SetStateAction<RegulationContract | null>>;
  setIsLoading: (isLoading: boolean) => void;
  currentLanguage: string;
  setCurrentLanguage: Dispatch<SetStateAction<string>>;
  regulationContent: IDocumentElementDetails | null;
  setRegulationContent: Dispatch<SetStateAction<IDocumentElementDetails | null>>;
  isLoadingContent: boolean;
  setIsLoadingContent: (isLoadingContent: boolean) => void;
}

const RegulationDataContext = createContext<RegulationDataContextContract | undefined>(undefined);

export default RegulationDataContext;
